<template>
        <div class="modal-card">

                    <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

                    <header class="modal-card-head" >
 

             
                    </header>



                    <section class="modal-card-body">    
                        <!-- {{dataDetail}}           -->
                     
                    <b-table
                                :data="isEmpty ? [] : dataDetail "
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards
                             
                        >

                        <b-table-column  label="รหัส"  v-slot="props">
                                  {{props.row.idpart  }} 
                        </b-table-column>
                        <b-table-column  label="รายการ"  v-slot="props">
                                  {{props.row.descp  }} 
                        </b-table-column>
                        <b-table-column  label=" จำนวน"  v-slot="props">
                                  {{formatStringToCurrency(props.row.amount)  }} 
                        </b-table-column>
                        <b-table-column  label="หน่วยนับ"  v-slot="props">
                                  {{props.row.unit_part_txt  }} 
                        </b-table-column>
                        <b-table-column  label="ราคาต่อหน่วย"  v-slot="props">
                                  {{ formatStringToCurrency(props.row.price)  }} 
                        </b-table-column>

                        <b-table-column  label="Invoice"  v-slot="props">
                                  {{  props.row.invoice  }} 
                        </b-table-column>

                        

                        <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                        </template>
                    </b-table>    
      
                   
                    
                    
                    </section>
                     <footer class="modal-card-foot"   style="justify-content: space-between;">
                        <b-button type="is-danger" @click="close">Close</b-button>      
                                        
                    </footer>



               



          

     </div>
</template>

<script>
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'
import { mapState } from 'vuex'
import formatStringToCurrency from '../../mixins/methods/formatStringToCurrency'

export default {
    name : "DlgDetailUsedPartByJobID",
    mixins:[formatStringToCurrency,],
    props:{
        isShowing : Boolean,
        dataProp : String,
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
        ...mapState({
            access_token : state => state.master_data.access_token ,
		}),
    },    
    methods:{
        close(){
          this.$emit('close')
        },
        loadData(){
             this.isLoadingFullPage = true
             const datTo = {
                "job_id" :  this.dataProp
             }
             axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
             axios.post(`${getBaseURLforBackEnd()}/api/get_detail_usedpartpatho_from_jobid`,datTo,getConfigAxios())
                  .then((res)=>{
                      this.dataDetail = res.data
                      this.isLoadingFullPage = false
                  }) 
        }
    },
    data(){
        return{
            isLoadingFullPage: false,
            isEmpty : false,
            dataDetail : [],
        }
    },
    watch:{
        isShowing:{
            immediate: true,
            handler: function(val){
                 if(val){
                    this.loadData()  
                 }
                
            }
        }
    }
}
</script>